// extracted by mini-css-extract-plugin
export default {"editButton":"PayrollMethod_editButton__OYmJM","TableBody":"PayrollMethod_TableBody__eXzA6","deleteButton":"PayrollMethod_deleteButton__SD4s6"};